<div class="wvImage" [ngClass]="hasBackdrop ? 'wvCustomItemDark' : 'wvCustomItemLight'">
    <div class="wvImageItem" [ngStyle]="{ 'background': 'url(../Admin/ImageResizer.aspx?imgid=' + imageState?.UploadedImageID + '&w=' + imgWidth + '&h=' + imgHeight + ') center center no-repeat' }"></div>
</div>

<div class="d-flex wvCustomItem wvSlideError" *ngIf="slideError">
    <div class="sadErrorBox">
        <div class="errorCharacter"></div>

        <div class="errorText d-inline-block">
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Uh_Oh">Uh Oh</div>
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Something_Went_Wrong">Something went wrong</div>
        </div>
    </div>
</div>
